import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

/**
 * Admin Schema
 * Represents a admin in the affiliate system
 */
export const LogSchema = Yup.object().transform(transformSnakeToCamel).shape({
  id: Yup.number().required(),
  action: Yup.string().required(),
  module: Yup.string().required(),
  description: Yup.string().required(),
  timestamp: Yup.date().required(),
})
